import { EventEmitter } from '@angular/core';
import { MeasureSearchCriteria } from '../../../../models/measure/measure-search-criteria';
import { Report } from '../../../../models/measure/report';
import { ActionSource, ActivePages, EventTrackerService, Page, TargetType, UserActionType } from '../../../services/event-tracker/event-tracker.service';
import { UserService } from '../../../services/user.service';
import { ProjectSelectionComponent } from '../project-selection/project-selection.component';
var MeasureFilterComponent = /** @class */ (function () {
    function MeasureFilterComponent(eventTracker, userService) {
        this.eventTracker = eventTracker;
        this.userService = userService;
        this.measureSearchCriteria = new MeasureSearchCriteria();
        this.generateReportEvent = new EventEmitter();
        this.editOrCreateProjectEvent = new EventEmitter();
        this.afterDeleteProjectEvent = new EventEmitter();
        this.showSearchBarEvent = new EventEmitter();
        this.clearFilterEvent = new EventEmitter();
        // this flag use to know when the search bar is open/close. Default is open
        this.showSearchBar = true;
    }
    MeasureFilterComponent.prototype.clearFilter = function () {
        this.clearFilterEvent.emit();
    };
    MeasureFilterComponent.prototype.generateReport = function (e, filter, mixPannelTargetType) {
        if (e && this.selectedReport) {
            this.segementTrackReportView(e.id, e.name, mixPannelTargetType);
        }
        // #160141066 Only Allow Selecting 1 Item When Rendering Reports
        this.measureSearchCriteria.project_id = undefined;
        this.measureSearchCriteria.influencerGroup = undefined;
        this.measureSearchCriteria.campaign_id = undefined;
        if (e) {
            this.measureSearchCriteria[filter] = e.id;
        }
        this.generateReportEvent.emit(this.measureSearchCriteria);
    };
    MeasureFilterComponent.prototype.showHideSearchbar = function (e) {
        this.showSearchBar = !this.showSearchBar;
        this.showSearchBarEvent.emit(this.showSearchBar);
    };
    MeasureFilterComponent.prototype.onEditOrCreateProject = function (project) {
        if (project.id > 0) {
            project.keywords = project.projectKeywords.map(function (item) { return item.keyword; });
            project.countries = project.projectCountries.map(function (item) { return item.country.id; });
            // track select project
            this.eventTracker.trackUserAction(UserActionType.VIEW, Page.PROJECT, {
                id: project.id,
                name: project.name,
                type: 'Project'
            }, undefined, undefined, {
                type: ActivePages.MEASURE
            });
        }
        this.editOrCreateProjectEvent.emit(project);
    };
    MeasureFilterComponent.prototype.afterDeleteProjectCallback = function (projectId) {
        if (this.measureSearchCriteria.project_id === projectId) {
            this.measureSearchCriteria.project_id = null;
        }
        this.afterDeleteProjectEvent.emit(projectId);
    };
    MeasureFilterComponent.prototype.closeTooltipManually = function (t) {
        if (t) {
            t.close();
        }
    };
    MeasureFilterComponent.prototype.segementTrackReportView = function (filterId, filterName, filterType) {
        this.eventTracker.trackUserAction(UserActionType.ACTION, Page.MEASURE, {
            id: filterType,
            name: filterType,
            type: TargetType.FILTER,
            filterName: filterName,
            filterId: filterId
        }, {
            action: UserActionType.TOGGLE,
            source: ActionSource.PAGE,
        }, {
            id: this.selectedReport.id,
            name: this.selectedReport.name
        }, {
            type: ActivePages.MEASURE,
            name: this.selectedReport.name,
            id: this.selectedReport.id
        });
    };
    Object.defineProperty(MeasureFilterComponent.prototype, "isFreeUser", {
        get: function () {
            return this.userService.isFreeUser();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MeasureFilterComponent.prototype, "projectDataForSegment", {
        get: function () {
            return {
                action: UserActionType.ACTION,
                item: Page.PROJECT,
                target: {
                    type: TargetType.PROJECT,
                },
                params: {
                    action: UserActionType.UPDATE
                }
            };
        },
        enumerable: true,
        configurable: true
    });
    return MeasureFilterComponent;
}());
export { MeasureFilterComponent };



// WEBPACK FOOTER //
// ./src/app/main/measure/measure-filter/measure-filter.component.ts.pre-build-optimizer.js